
import { mapState } from 'vuex';
import LandingPageProduct from './LandingPageProduct';

export default {
  name: 'LandingPageUnpaidOrdersSection',
  components: { LandingPageProduct },
  computed: {
    ...mapState('crmLandingPage', ['unpaidOrders', 'totalUnpaidPrice'])
  },
  methods: {
    bankAccount(unpaidOrder) {
      return this.$t('order.bank_account', [
        unpaidOrder.bank_name,
        unpaidOrder.bank_account_no,
        unpaidOrder.recipient_name
      ]);
    },
    copyBankAccountNo(unpaidOrder) {
      navigator.clipboard.writeText(this.bankAccount(unpaidOrder));
    }
  }
};
